<script setup lang="ts">
import MobileSidebarRegularLink from './MobileSidebarRegularLink.vue'
import type { IMenuLinks } from './types'
const props = defineProps<{ title: string; slug: keyof IMenuLinks; links: IMenuLinks }>()
</script>

<template>
  <AccordionItem :value="`menu-item-${props.slug}`" class="border-0">
    <AccordionTrigger class="font-sans [&>svg]:mr-2.5"
      ><div class="flex gap-2"><slot name="icon" />{{ props.title }}</div></AccordionTrigger
    >
    <AccordionContent class="flex flex-col items-start gap-3.5 font-semibold">
      <SheetClose as-child>
        <slot name="header" />
      </SheetClose>
      <template v-for="(group, groupIndex) in props.links[props.slug]" :key="groupIndex">
        <MobileSidebarRegularLink
          v-for="(link, linkIndex) in group"
          :key="`${groupIndex}-${linkIndex}`"
          :to="link.url"
        >
          <div class="flex items-center gap-1.5">
            <component :is="link.icon" v-if="link.icon" class="size-4 text-gray-500" />
            {{ $t(link.title) }}
          </div>
        </MobileSidebarRegularLink>
      </template>
      <SheetClose as-child>
        <slot name="footer" />
      </SheetClose>
    </AccordionContent>
  </AccordionItem>
</template>
